/* Arrival windows.
 *
 * Shared by the product page and the cart. Both render a plain business-day
 * range server-side first — "Arrives in 6–10 business days" — and this upgrades
 * it to real dates. If the script never runs, or Intl is missing, the range
 * stands and is still true.
 *
 * A theme cannot ask a carrier anything, so none of this is a quoted rate: it
 * is production days plus transit days, counted in business days from today.
 */
(function () {
  'use strict';

  // Business days only: the print partner does not print on Saturday and the
  // post does not move on Sunday, so a raw "+7 days" would promise a date that
  // cannot happen.
  function addBusinessDays(from, days) {
    var date = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }

  function formatDate(date) {
    try {
      return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch (e) {
      return null;
    }
  }

  var shipping = document.querySelector('[data-shipping]');
  if (shipping) {
    var makeMin = parseInt(shipping.getAttribute('data-make-min'), 10);
    var makeMax = parseInt(shipping.getAttribute('data-make-max'), 10);
    var today = new Date();

    Array.prototype.forEach.call(shipping.querySelectorAll('[data-arrival]'), function (note) {
      var transitMin = parseInt(note.getAttribute('data-transit-min'), 10);
      var transitMax = parseInt(note.getAttribute('data-transit-max'), 10);
      if (isNaN(makeMin) || isNaN(transitMin)) return;

      var earliest = formatDate(addBusinessDays(today, makeMin + transitMin));
      var latest = formatDate(addBusinessDays(today, makeMax + transitMax));
      // No dates means no Intl — keep the business-day range already rendered.
      if (earliest && latest) note.textContent = 'Arrives ' + earliest + ' – ' + latest;
    });

    Array.prototype.forEach.call(shipping.querySelectorAll('[data-ship-radio]'), function (radio) {
      radio.addEventListener('change', function () {
        Array.prototype.forEach.call(shipping.querySelectorAll('[data-ship-card]'), function (card) {
          card.classList.toggle('radio-card--selected', card.contains(radio) && radio.checked);
        });
      });
    });
  }
})();
